/**
 * copyEditMode: the admin's "Edit copy" switch, as a tiny external store so
 * the main menu (toggle) and the CopyEditMode overlay (consumer) never need
 * a shared React context. Web + native alike: the overlay is plain DOM.
 */
import { useSyncExternalStore } from "react";
import { COPY_EDIT_CLASS } from "@/lib/copyEditModeClass";

let active = false;
const listeners = new Set<() => void>();

function emit(): void {
  for (const l of listeners) l();
}

export function isCopyEditActive(): boolean {
  return active;
}

export function setCopyEditActive(next: boolean): void {
  if (active === next) return;
  active = next;
  if (typeof document !== "undefined") document.documentElement.classList.toggle(COPY_EDIT_CLASS, next);
  emit();
}

export function toggleCopyEdit(): void {
  setCopyEditActive(!active);
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useCopyEditActive(): boolean {
  return useSyncExternalStore(subscribe, isCopyEditActive, () => false);
}
